import React, { useContext } from 'react'

import isUndefined from 'lodash/isUndefined'

import { StyledExpander, StyledCell, StyledRow } from './StyledDataTable'
import { DataTableContext } from './DataTable'

const getClassName = (i, className) => {
	let name = 'cell'
	if (i === 0) {
		return `${name} first-cell`
	}
	if (className) {
		return `${name} ${className}`
	}
	return name
}

const TableRows = ({ index, rowStyle, selectedRow, rowSelectHandler }) => {
	const { rows, rowHeight, prepareRow, additionalWidth, withSelectRow, onSelect, isSelected } = useContext(DataTableContext)

	if (rows && (!isUndefined(index)) && (index !== null)) {
		const row = rows[index]
		prepareRow(row)
		return (
			<StyledRow
				{...row.getRowProps()}
				isSelected={(row.id === selectedRow) || (isSelected && isSelected(row.original))}
				withSelectRow={withSelectRow || (onSelect && isSelected)}
				onClick={() => rowSelectHandler(row)}
				row={row}
				style={rowStyle}
			>
				{row.cells.map((cell, i) => {
					return cell ? (
						<StyledCell
							{...cell.getCellProps([
								{
									className: getClassName(i, cell.column.className),
									style: {
										...cell.column.style,
										height: rowHeight,
										minWidth: cell.column.width + additionalWidth
									},
									rowIndex: row.index
								}
							])}
						>
							{cell.isGrouped ? (
								<>
									<StyledExpander isOpen={row.isExpanded} {...row.getToggleRowExpandedProps()}/>
									{cell.render('Cell')} ({row.subRows.length})
								</>
							) : cell.isAggregated ? (
								cell.render('Aggregated')
							) : cell.isPlaceholder ? null : (
								cell.render('Cell')
							)}
						</StyledCell>
					) : null
				})
				}
			</StyledRow>
		)
	}
	return null
}

export default TableRows
